import React,{useState,useEffect} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import { upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

const AddressInfo = ({nexTabChange}) => {
    const {userDetail,setUserDetail} = StateUseContext();

    const [address1, setAddress1] = useState({ value: '', error: '' });
    const [address2, setAddress2] = useState({ value: '', error: '' });
    const [area, setArea] = useState({ value: '', error: '' });
    const [pincode, setPincode] = useState({  value: '', error: '' });
    const [landmark, setLandmark] = useState({  value: '', error: '' });

    const [loading,setLoading] = useState(false);

    useEffect(() => {
        if (userDetail !== undefined) {
            setArea({ ...area, value: userDetail?.area || '' })
            setAddress1({ ...address1, value: userDetail?.address1 || '' })
            setAddress2({ ...address2, value: userDetail?.address2 || '' })
            setPincode({...pincode, value:userDetail?.zip_code || ''})
            setLandmark({...landmark, value:userDetail?.landmark || ''})
        }
    }, [userDetail.area,userDetail.address1,userDetail.address2,userDetail.zip_code,userDetail.landmark])

    // Validation
    const validation = () => {
        let formIsValid = true
        //    Address 1
        if (!address1.value) {
            formIsValid = false
            let msg = "Please enter your Address"
            setAddress1({ ...address1, error: msg })
        }
        else if (address1.value.length <= 3) {
            formIsValid = false
            let msg = "Min 4 Digit Length"
            setAddress1({ ...address1, error: msg })
        }
        else if (address1.value.length >= 128) {
            formIsValid = false
            let msg = "Max 128 Digit Length"
            setAddress1({ ...address1, error: msg })
        }


        // Area
        if (!area.value) {
            formIsValid = false
            let msg = "Please enter your area"
            setArea({ ...area, error: msg })
        }
        if (!pincode.value) {
            formIsValid = false
            let msg = "Please enter your pincode"
            setPincode({...pincode,error:msg})  
        }

        if (!landmark.value) {
            formIsValid = false
            let msg = "Please enter landmark"
            setLandmark({...pincode,error:msg})  
        }

        else if (area.value.length <= 3) {
            formIsValid = false
            let msg = "Min 4 Digit Length"
            setArea({ ...area, error: msg })
        }
        else if (area.value.length >= 128) {
            formIsValid = false
            let msg = "Max 128 Digit Length"
            setArea({ ...area, error: msg })
        }
       


        if (formIsValid) {
            setAddress1({...address1, error : ''});
            setArea({...area, error : ''});
            setLandmark({...landmark, error : ''});
            setPincode({...pincode, error : ''});
        }

        return formIsValid;

    }


    const submitFormHandler = async(e) => {
        e.preventDefault();

        if(validation()){
            setLoading(true)
            const data = {
                id:userDetail?.id,
                address1:address1.value,
                address2:address2.value,
                area:area.value,
                landmark:landmark.value,
                zip_code:pincode.value
                
            }

            try {
                await upadateProfileDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false)
                        setUserDetail({...userDetail,...res?.data})
                        swal(res?.message,'','success')
                    }
                    else{
                        setLoading(false)
                        swal(res?.message,'','error')
                    }
                })
            } catch (error) {
                console.log('update profile..',error)
            }
        }
    }

  return (
    <>
        <p className="text-info border-3 mt-2 mb-2 border-start ps-2 bg-light py-2 mb-4 border-info fw-semibold" style={{fontSize:'15px'}}>  
        <b>Note: </b><br></br> 1. Please provide complete Address for Study Material dispatch in <b className='text-primary'><u>{userDetail?.country_name}</u></b>  <br></br> 2. Study materials will not be dispatched to addresses within India.</p>

      

        <form onSubmit={submitFormHandler} className="row">
            <div className="col-md-6 mb-3">
                <label  className="form-label">Address Line 1<span>*</span></label>
                <input type="text"
                    className="form-control" placeholder="Enter Address 1"
                    value={address1.value !==null ? address1.value : ''}
                    onChange={(e) => setAddress1({ ...address1, value: e.target.value, error: '' })}
                />
                {address1.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{address1.error}</small>}
            </div>
            <div className="col-md-6 mb-3">
                <label  className="form-label">Address Line 2 (Optional)</label>
                <input type="text"
                className="form-control" placeholder="Enter Address 2 "
                value={address2.value!==null?address2.value:''}
                onChange={(e) => setAddress2({ ...address2, value: e.target.value, error: '' })} />
                {address2.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{address2.error}</small>}

            </div>
            <div className="col-md-6 mb-3">
                <div className="row gx-3">
                    <div className="col-lg-6">
                        <label className="form-label">Postal Zip Code<span>*</span></label>
                        <input type="text"
                        className="form-control"
                        placeholder="Enter Zip Code..."
                        value={pincode.value !==null ? pincode.value : ''}
                        onChange={(e) => setPincode({ ...pincode, value: e.target.value, error: '' })}
                    />
                    {pincode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{pincode.error}</small>}

                    </div>

                    <div className="col-lg-6 mt-3 mt-lg-0">
                        <label className="form-label">Area<span>*</span></label>
                        <input type="text"
                        className="form-control" placeholder="Enter Area..."
                        value={area.value!==null?area.value:''}
                        onChange={(e) => setArea({ ...area, value: e.target.value, error: '' })} />
                        {area.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{area.error}</small>}

                    </div>

                    
                </div>
            </div>

            <div className="col-lg-6 mt-3 mt-lg-0">
                        <label className="form-label">Landmark<span>*</span></label>
                        <input type="text"
                        className="form-control" placeholder="Enter Landmark"
                        value={landmark.value!==null?landmark.value:''}
                        onChange={(e) => setLandmark({ ...landmark, value: e.target.value, error: '' })} />
                        {landmark.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{landmark.error}</small>}

                    </div>

            <div className="col-md-12 mt-2">
            {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                        Updating...</button>:<button type="submit" className="btn btn-default">Save</button>}
            {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
            </div>
        </form>
    </>
  )
}

export default AddressInfo